// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "calendar" + "." + "1f5abf5a2cd9913924e4" + ".js";
};